import React from "react";
import { Receiver } from "generated/graphql";
import useText from "constants/text";
import { formatPhoneNumber } from "utils";

export interface Column<RowData> {
  title: string;
  field: string;
  render?(data: RowData): React.ReactNode;
}

export const useReceiversColumns = (): Column<Partial<Receiver>>[] => {
  const { text } = useText();
  return [
    {
      field: "receiver_firstname",
      title: `${text.all.first_name}`,
    },
    {
      field: "receiver_lastname",
      title: `${text.all.last_name}`,
    },
    {
      field: "receiver_phone_number",
      title: `${text.all.phone_number}`,
      render: ({ receiver_phone_number }) => <> {formatPhoneNumber(receiver_phone_number)} </>,
    },
    {
      field: "receiver_address",
      title: `${text.all.address}`,
      render: ({ receiver_address }) => <> {receiver_address?.address.substring(0, 45) + "..."}</>,
    },
  ];
};
